import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import {
  addPaymentGatewayConfig,
  getPaymentGatewayConfigName,
  updatePaymentGatewayConfig,
} from "../../../services/PaymentGatewayConfig/PaymentGatewayConfig";
import { Dropdown } from "primereact/dropdown";
import AdminMenu from "../../AdminMenu";
import { Checkbox } from "primereact/checkbox";
import {
  addTimeSlot,
  updateTimeSlot,
} from "../../../services/TimeSlot/TimeSlot";

const TimeSlotCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const slotsListOne = [
    {
      slotKey: 0,
      value: "00 AM To 01 AM",
    },
    {
      slotKey: 1,
      value: "01 AM To 02 AM",
    },
    {
      slotKey: 2,
      value: "02 AM To 03 AM",
    },
    {
      slotKey: 3,
      value: "03 AM To 04 AM",
    },
    {
      slotKey: 4,
      value: "04 AM To 05 AM",
    },
    {
      slotKey: 5,
      value: "05 AM To 06 AM",
    },
    {
      slotKey: 6,
      value: "06 AM To 07 AM",
    },
    {
      slotKey: 7,
      value: "07 AM To 08 AM",
    },
    {
      slotKey: 8,
      value: "08 AM To 09 AM",
    },
    {
      slotKey: 9,
      value: "09 AM To 10 AM",
    },
    {
      slotKey: 10,
      value: "10 AM To 11 AM",
    },
    {
      slotKey: 11,
      value: "11 AM To 12 PM",
    },
    {
      slotKey: 12,
      value: "12 PM To 01 PM",
    },
    {
      slotKey: 13,
      value: "01 PM To 02 PM",
    },
    {
      slotKey: 14,
      value: "02 PM To 03 PM",
    },
    {
      slotKey: 15,
      value: "03 PM To 04 PM",
    },
    {
      slotKey: 16,
      value: "04 PM To 05 PM",
    },
    {
      slotKey: 17,
      value: "05 PM To 06 PM",
    },
    {
      slotKey: 18,
      value: "06 PM To 07 PM",
    },
    {
      slotKey: 19,
      value: "07 PM To 08 PM",
    },
    {
      slotKey: 20,
      value: "08 PM To 09 PM",
    },
    {
      slotKey: 21,
      value: "09 PM To 10 PM",
    },
    {
      slotKey: 22,
      value: "10 PM To 11 PM",
    },
    {
      slotKey: 23,
      value: "11 PM To 00 AM",
    },
  ];

  const slotsListTwo = [
    {
      slotKey: 0,
      value: "00 AM To 02 AM",
    },
    {
      slotKey: 2,
      value: "06 AM To 04 AM",
    },
    {
      slotKey: 4,
      value: "04 AM To 06 AM",
    },
    {
      slotKey: 6,
      value: "06 AM To 08 AM",
    },
    {
      slotKey: 8,
      value: "08 AM To 10 AM",
    },
    {
      slotKey: 10,
      value: "10 AM To 12 PM",
    },
    {
      slotKey: 12,
      value: "12 PM To 02 PM",
    },
    {
      slotKey: 14,
      value: "02 PM To 04 PM",
    },
    {
      slotKey: 16,
      value: "04 PM To 06 PM",
    },
    {
      slotKey: 18,
      value: "06 PM To 08 PM",
    },
    {
      slotKey: 20,
      value: "08 PM To 10 PM",
    },
    {
      slotKey: 22,
      value: "10 PM To 12 AM",
    },
  ];

  const slotsListThree = [
    {
      slotKey: 0,
      value: "00 AM To 03 AM",
    },
    {
      slotKey: 3,
      value: "03 AM To 06 AM",
    },
    {
      slotKey: 6,
      value: "06 AM To 09 AM",
    },
    {
      slotKey: 9,
      value: "09 AM To 12 PM",
    },
    {
      slotKey: 12,
      value: "12 PM To 03 PM",
    },
    {
      slotKey: 15,
      value: "03 PM To 06 PM",
    },
    {
      slotKey: 18,
      value: "06 PM To 09 PM",
    },
    {
      slotKey: 21,
      value: "09 PM To 00 AM",
    },
  ];

  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);
  const [gatewayNameData, setGatewayNameData] = useState([]);

  const [slotTimeDuration, setSlotTimeDuration] = useState(2);
  const SlotTimeDurationData = [1, 2, 3];
  const [slotList, setSlotList] = useState(slotsListTwo);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState([]);
  const [timeSlotError, setTimeSlotError] = useState(false);

  let slotsList = []; // use `let` so it can be reassigned

  const handleTimeSlot = (slotValue) => {
    setSelectedTimeSlot([]);
    setSlotTimeDuration(slotValue);

    if (slotValue === 1) {
      slotsList = slotsListOne;
    } else if (slotValue === 2) {
      slotsList = slotsListTwo;
    } else if (slotValue === 3) {
      slotsList = slotsListThree;
    }

    // Do something with slotsList here, e.g., set to state:
    setSlotList(slotsList);
  };

  useEffect(() => {}, [item]);

  const handleTimeSlotSelectionToggle = (status) => {
    const updatedStatus = [...selectedTimeSlot];

    if (updatedStatus.includes(status)) {
      // Remove status if already selected
      updatedStatus.splice(updatedStatus.indexOf(status), 1);
    } else {
      // Add status if not selected
      updatedStatus.push(status);
    }

    setSelectedTimeSlot(updatedStatus);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    let isValid = true;
    if (selectedTimeSlot.length === 0) {
      setTimeSlotError("Please Select Time Slot");
      isValid = false;
    }

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          brandId: brandId,
          slots: selectedTimeSlot,
        };

        const UpdateData = {
          ...item,
          brandId: brandId,
          slots: selectedTimeSlot,
        };

        // Call the service function for creating pickup request

        if (!isUpdating) {
          addTimeSlot(data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/Time-Slot");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updateTimeSlot(UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/Time-Slot");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Time-Slot")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Time Slot {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className=" mt-4 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="SlotTimeDuration"
              value={slotTimeDuration}
              onChange={(e) => handleTimeSlot(e.target.value)}
              options={SlotTimeDurationData}
              placeholder="Slot Time Duration"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />

            <label
              htmlFor="SlotTimeDuration"
              className="text-md"
              style={{ color: "blue" }}
            >
              Slot Time Duration (In Hour){" "}
              <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          {slotList?.map((item) => (
            <div
              key={item.id}
              className="flex flex-1 justify-content-between my-1 px-2"
              style={{backgroundColor:selectedTimeSlot.includes(item) ? "#1752AA" : null, borderRadius:30}}
            >
              {/* <p className="text-xl font-medium">{item.name}</p> */}
              <p className="text-xl font-medium" style={{color:selectedTimeSlot.includes(item) ? "#fff" : "#000"}}>{item.value}</p>
              <div className="flex justify-content-center align-items-center">
                <Checkbox
                  checked={selectedTimeSlot.includes(item)}
                  size="20" // Increased size
                  color={
                    selectedTimeSlot.includes(item) ? "#00A3FF" : "#C1C9D3"
                  }
                  onClick={() => handleTimeSlotSelectionToggle(item)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="mx-4 my-2">
        {timeSlotError && (
          <p className="text-lg font-normal" style={{ color: "red" }}>
            {timeSlotError}
          </p>
        )}
      </div>

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default TimeSlotCreate;
